class ProductEngraving extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			toggleModal: '.product-engraving__toggle-modal',
			triggerPersonalisation: '.trigger-personalisation',
			triggerParrent: '.product-engraving__main-button',
			modalPersonalisation: '.product-engraving__main',
			engravingInput: '.product-engraving__input-selector',
			engravingButton: '.product-engraving__button',
			engravingText: '.product-engraving__preview',
			engravingTextLetters: '.product-engraving__letter',
			engravingMaxLength: '.product-engraving__max-number-characters',
			engravingDetails: '#engravingDetails',
			addedEngraving: '.engraving-added',
			removeEngravingButton: '.product-engraving__remove-added-engraving',
			variantSelected: 'select.variant-selector',
			summary: '.product-engraving__summary',
			summaryContent: '.product-engraving__summary .summary__content',
			headingBefore: '.product-engraving__heading--before',
			headingAfter: '.product-engraving__heading--after',
		};

		this.elements = {
			toggleModalButtons: this.querySelectorAll(this.selectors.toggleModal),
			triggerPersonalisation: this.querySelector(this.selectors.triggerPersonalisation),
			triggerPersonalisationParent: this.querySelector(this.selectors.triggerParrent),
			modalPersonalisation: this.querySelector(this.selectors.modalPersonalisation),
			engravingInput: this.querySelector(this.selectors.engravingInput),
			engravingButton: this.querySelector(this.selectors.engravingButton),
			engravingText: this.querySelector(this.selectors.engravingText),
			engravingTextLetters: this.querySelectorAll(this.selectors.engravingTextLetters),
			engravingMaxLength: this.querySelector(this.selectors.engravingMaxLength),
			removeEngravingButton: this.querySelector(this.selectors.removeEngravingButton),
			engravingDetails: this.querySelector(this.selectors.engravingDetails),
			summary: this.querySelector(this.selectors.summary),
			summaryContent: this.querySelector(this.selectors.summaryContent),
			headingBefore: this.querySelector(this.selectors.headingBefore),
			headingAfter: this.querySelector(this.selectors.headingAfter),
		};

		this.classes = {
			modalVisible: 'product-engraving--visible',
			engravingPreview: 'product-engraving__preview',
			engravingPreviewLetter: 'product-engraving__letter',
			engravingPreviewLetters: 'product-engraving__letters',
			buttonLoad: 'vm-button--loading',
			engravingAdded: 'engraving-added',
			engravingButon: 'trigger-personalisation',
			disabled: 'disabled',
			displayNone: 'hidden',
		};

		this.productForm = this.closest('.product-form')
				? this.closest('.product-form').querySelector('buy-buttons form')
					? this.closest('.product-form').querySelector('buy-buttons form')
					: false
				: false;
		this.formData;
		this.init();
	}

	init() {
		window.currentProductPersonalisation = {
			text: '',
		};

		this.addListeners();
	}

	addListeners() {
		// Toggle modal (close/open)
		this.elements.toggleModalButtons.forEach((button) =>
			button.addEventListener('click', (event) => {
				event.preventDefault();
				this.elements.modalPersonalisation.classList.toggle(this.classes.modalVisible);

				if (!document.querySelector(this.selectors.addedEngraving) && button.classList.contains(this.classes.engravingButon)) {
					this.elements.engravingInput.value = '';
				}
			})
		);

		this.elements.engravingInput.addEventListener('input', (event) => this.handleTextChange(event));

		this.elements.engravingButton.addEventListener('click', (event) => {
			event.preventDefault();
			currentProductPersonalisation.text = this.elements.engravingInput.value;

			this.modifyForm(currentProductPersonalisation.text);
			this.updateUI('added');
		});

		this.elements.removeEngravingButton.addEventListener('click', async (event) => {
			event.preventDefault();
			this.modifyForm('');
			this.updateUI('removed');
		});
	}

	updateUI(method) {
		if (method == 'added') {
			this.elements.removeEngravingButton.classList.remove(this.classes.displayNone);
			this.elements.triggerPersonalisationParent.querySelector('span').classList.add(this.classes.engravingAdded);
			this.elements.engravingButton.classList.remove(this.classes.buttonLoad);
			this.elements.engravingButton.classList.remove(this.classes.disabled);
			this.elements.engravingButton.textContent = this.elements.engravingButton.dataset.modifyText;
			this.elements.triggerPersonalisation.textContent = this.elements.triggerPersonalisation.dataset.modifyText;
			this.elements.summaryContent.innerHTML = `<strong>Text</strong>: "${currentProductPersonalisation.text}"`
			this.elements.summary.classList.remove(this.classes.displayNone);
			this.elements.headingBefore.classList.add(this.classes.displayNone);
			this.elements.headingAfter.classList.remove(this.classes.displayNone);
			this.elements.modalPersonalisation.classList.remove(this.classes.modalVisible);
		} else if (method == 'removed') {
			this.elements.removeEngravingButton.classList.add(this.classes.displayNone);
			this.elements.engravingButton.classList.add(this.classes.buttonLoad);
			this.elements.engravingButton.classList.add(this.classes.disabled);
			this.elements.triggerPersonalisation.textContent = this.elements.triggerPersonalisation.dataset.addText;
			this.elements.engravingButton.textContent = this.elements.engravingButton.dataset.addText;
			this.elements.summary.classList.add(this.classes.displayNone);
			this.elements.summaryContent.innerHTML = '';
			this.elements.headingBefore.classList.remove(this.classes.displayNone);
			this.elements.headingAfter.classList.add(this.classes.displayNone);

			document.querySelector(this.selectors.addedEngraving).classList.remove('engraving-added');
			this.elements.engravingInput.value = '';
			currentProductPersonalisation.text = '';
			this.elements.engravingTextLetters.forEach((item) => (item.innerHTML = ''));
			this.elements.engravingText.innerHTML = '';
		} else {
			this.elements.engravingButton.classList.add(this.classes.buttonLoad);
			this.elements.modalPersonalisation.classList.remove(this.classes.modalVisible);
		}
	}

	handleTextChange(el) {
		const textValue = el.target.value.trim();
		const textInput = el.target;

		const textLength = textValue.length;
		this.elements.engravingButton.classList.remove(this.classes.disabled);

		if (textLength == 0) {
			this.elements.engravingText.innerHTML = '';
			this.elements.engravingButton.classList.add(this.classes.disabled);
		} else if (textLength <= this.elements.engravingMaxLength.innerHTML) {
			this.elements.engravingText.innerHTML = textInput.value;
			this.elements.engravingButton.classList.remove(this.classes.disabled);
		}

		currentProductPersonalisation.text = textInput.value;
	}

	modifyForm(value) {
		this.productForm.querySelector("input[name='properties[Engraving Letters]']")
				? this.productForm.querySelector("input[name='properties[Engraving Letters]']").remove()
				: '';

			if (value && value.length > 0 && value.trim() != "") {
				const newInput = document.createElement('input');
				newInput.type = 'hidden';
				newInput.name = 'properties[Engraving Letters]';
				newInput.value = value;

				this.productForm.appendChild(newInput);
				this.productForm.setAttribute('data-additional-product', this.dataset.additionalProduct);
				this.productForm.setAttribute('data-additional-product-property', value);
			} else {
				this.productForm.removeAttribute('data-additional-product', '');
				this.productForm.removeAttribute('data-additional-product-property', '');
			}
	}


	 debounce(fn, wait = 300) {
		let t;
		return (...args) => {
		  clearTimeout(t);
		  t = setTimeout(() => fn.apply(this, args), wait);
		};
	  }
}

window.customElements.define('product-engraving', ProductEngraving);
